/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export class NoopLogRecordProcessor {
    forceFlush() {
        return Promise.resolve();
    }
    onEmit(_logRecord, _context) { }
    shutdown() {
        return Promise.resolve();
    }
}
//# sourceMappingURL=NoopLogRecordProcessor.js.map